import { RouterProvider } from 'react-router-dom';
import { router } from '@/app/router';

import { useAndroidBackButton } from './useAndroidBackButton';
import { useStatusBar } from './useStatusBar';
import { useTestgateConnectListener } from './useTestgateConnectListener';
import { useZoomConnectListener } from './useZoomConnectListener';

import GlobalAlertDialog from './GlobalAlertDialog';
import GlobalToastAlert from './GlobalToastAlert';
import GlobalLoadingOverlay from './GlobalLoadingOverlay';
import ZoomConnectOverlay from './ZoomConnectOverlay';
import DevelopmentStatusRibbon from './DevelopmentStatusRibbon';

export default function App() {
  // 네이티브(Capacitor) 셸 위에서만 의미 있는 훅들 — 웹 브라우저에서는 내부적으로 no-op한다.
  useAndroidBackButton();
  useStatusBar();
  useTestgateConnectListener();
  useZoomConnectListener();

  return (
    <>
      <GlobalAlertDialog />
      <GlobalToastAlert />
      <GlobalLoadingOverlay />
      <ZoomConnectOverlay />
      <DevelopmentStatusRibbon />

      <RouterProvider router={router} />
    </>
  );
}
